import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(private dataService: DataService) { }

  saveProduct(saveProduct: any) {
    return this.dataService.post('/api/product/postProduct', saveProduct);
  }

  deleteProduct(productId: number) {
    return this.dataService.delete('/api/product/deleteProduct/?productId=' + productId);
  };

  activateProduct(productId: number) {
    return this.dataService.delete('/api/product/activateProduct/?productId=' + productId);
  };

  getProducts(SearchQuery: string) {
    return this.dataService.getRecordWithParams('/api/product/getProducts', SearchQuery);
  };

  getResellerProducts(SearchQuery: string) {
    return this.dataService.getRecordWithParams('/api/product/getResellerProducts', SearchQuery);
  };

  //getProductConnectionFeeForEdit  (searchQuery:string) {
  //    return this.dataService.post('/api/product/getProductConnectionFeeForEdit', SearchQuery);
  //};

  saveProductSubCategory(SearchQuery: string) {
    return this.dataService.post('/api/product/saveProductSubCategory', SearchQuery);
  };

  deleteProductSubCategory(id: number) {

    return this.dataService.getRecord('/api/product/deleteProductSubCategory/' + id);
  };

  getFeatureLogo(id: number) {

    return this.dataService.getRecord('/api/product/getFeatureLogo/' + id);
  };

  //getFeature  (Id:number) {
  //
  //    return this.dataService.getRecord('/api/product/getFeature/' + id);
  //};

  saveProductFeature(SearchQuery: string) {
    return this.dataService.post('/api/product/saveProductFeature', SearchQuery);
  };

  saveProductLogoList(SearchQuery: string) {
    return this.dataService.post('/api/product/saveProductLogoList', SearchQuery);
  };

  getProductsForEdit(productId: number) {
    return this.dataService.getRecord('/api/product/getProductsForEdit/?productId=' + productId);
  }
  getAllProductSubCategory() {

    return this.dataService.getRecord('/api/ProductSubCategory/getAllProductSubCategory');
  }
  getAllProducts  () {
    return this.dataService.getRecord('/api/product/getAllProducts');
  }

  getProductsByConnectionId(connectionId: number) {
    return this.dataService.getRecord('/api/product/getProductsByConnectionId/' + connectionId);
  }

  getProductSubCategory(subcategoryId: number) {
    return this.dataService.getRecord('/api/product/getProductSubCategory/' + subcategoryId);
  }

  zeroDefaultImage(productLogoId: number) {
    return this.dataService.getRecord('/api/product/zeroDefaultImage/' + productLogoId);
  }

  getProductLogoImageName(productLogoId: number) {
    return this.dataService.getRecord('/api/product/getProductLogoImageName/' + productLogoId);
  }

  getAllProductsByServiceProviderid(serviceProviderId: number) {
    return this.dataService.getRecord('/api/product/getAllProductsByServiceProviderId/' + serviceProviderId);
  }

  getServiceChangeReqByConnnectionAndProduct(connectionId: number, productId: number) {

    return this.dataService.getRecord('/api/ServiceChangeRequest/ServiceChangeReqByConnnectionAndProduct/' + connectionId + "/" + productId);
  }
  getAllProductByServiceProviderIdAndProductId(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/product/getAllProductByServiceProviderIdAndProductId', searchQuery);
  }

  getProductClassificationByServiceProviderId(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/product/getProductClassificationByServiceProviderId', searchQuery);
  }

  postProductLogo(searchQuery: string) {

    return this.dataService.post('/api/product/postProductLogo', searchQuery);
  }

  deleteProductLogo(logoId: number) {
    return this.dataService.getRecord('/api/product/deleteProductLogo/' + logoId);
  }

  loadProductLogoImages(productDetailId: number) {
    return this.dataService.getRecord('/api/product/loadProductLogoImages/' + productDetailId);
  }

  saveProductLogoImagesDefault(productLogoId: number) {
    return this.dataService.getRecord('/api/product/saveProductLogoImagesDefault/' + productLogoId);
  }
  getSubCategoryById(subCategoryId: number) {
    return this.dataService.getRecord('/api/ProductSubCategory/getProductSubCategoryById/' + subCategoryId);
  }

  saveResellerProductCost(data: any) {
    return this.dataService.post('/api/productDetail/UpdateResellerProductCost', data);
  }
}
